import { IS_HEBREW_INSTALLATION } from './app-common';

export const CURRENCY_CENTS_COUNT = 100;
export const CURRENCY_CODE = IS_HEBREW_INSTALLATION ? '₪' : '$';
